// extracted by mini-css-extract-plugin
export default {"header":"Header_header__pEFZb","inputWrap":"Header_inputWrap__RJ3zD","searchInput":"Header_searchInput__zmulv"};